import styled, { css } from "styled-components"
import { ListItem } from '@mui/material'

const dropdownAnimation = css`
    transition: width 0.5s;
    &:hover{
        width: 80%;
    }
`;

const fullInfoUI  = css`
    background-color: var(--dark2);
    border: 1px solid var(--datasetBorder);
`

const beforeInfoUI = css`
    background-color: transparent;
    border: 1px dashed var(--divider);
`

const unclickableUI = css`
    color: var(--textSecondary);
    opacity: 0.4;
    cursor: auto;
`

const cropValue = css`
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden; 
  white-space: nowrap;
`

const kpiSelectedBorder = css`
    border: 3px solid var(--textPrimary);
`

//dataset dropdown
export const DatasetButton = styled.button`
    padding:0;
    height: 52px;
    width: 100%;
    cursor: pointer;
    ${props => props.theme.done ? fullInfoUI : beforeInfoUI}
    ${props => props.disabled && unclickableUI}
    ${props => props.isCurrent && kpiSelectedBorder}
    .addData{
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: var(--textPrimary);
    }
    .selectedData{
        position: relative;
        display: flex;
        align-items: center;
        padding-left: 9.5px;
        .selectedData__info{
            width: 100%;
            &>p{
                margin:0;
                text-align: left;
                ${cropValue}
            }
            .selectedData__color{
                margin-top: 9px;
                color: ${props => props.theme.dropdownColor};
            }
            .smallFont{
                color: var(--textSecondary);
                font-size: 10px;
            }
        }
        .menuItems {
            li{
                display: flex;
                gap: 10px ;
            }
        }
    }
`;

export const DropDownContainer = styled.div`
    width: 600px;
    height: 302px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    .dropdown{
        height: ${(props) =>  `calc(100% - ${props.isOpen ? '50px' : '0px'});`};
        display:flex;
        justify-content: space-between;
        .dropdownRight{
            width: 50%;
        }
        .dropdownLeft{
            width: 50%;
        }
        &>div{
            display: flex;
            flex-direction: column;
            overflow: hidden;
            ${dropdownAnimation}
            .dropdownBody{
                flex: 1;
                border-left: 1px solid var(--divider);
                flex-grow: 1;
                overflow-y: auto;
                scrollbar-color: ${(props) => props.theme.dropdownColor} rgba(0,0,0,0);
                &::-webkit-scrollbar-thumb {
                    background: ${(props) => props.theme.dropdownColor};
                }
                &::-webkit-scrollbar-track {
                    background: rgba(0,0,0,0);
                }
            }
        }
    }
    .dropdown-footer {
        width: 100%;
        border-top: 1px solid var(--divider);
        display: flex;
        align-items: center;
        justify-content: flex-end;
        p {
            margin-right: 10px;
            color: var(--stockUp);
            border-bottom: 1px dotted var(--stockUp);
            cursor: pointer;
        }
    }
`;

export const DropDownInputHeader = styled.div`
    display:flex;
    border-bottom: 1px solid var(--divider);
    position: sticky;
    top: 0;
    left: 0;
    padding: 0 8px 5px 12px;
    align-items: center;
    & > :first-child {
        margin-right: 8px;
    }
`;

export const OpenText = styled.p`
    margin:0;
    color: ${(props) => props.theme.dropdownColor};
    margin-right: 7px;
`;

export const Value = styled.div`
    ${cropValue}
`;

export const SelectContainer = styled.div`
    > * {
        border: 1px solid var(--divider);
        border-radius: 4px;
        background-color: transparent;
    }
`;

export const StylesListItem = styled(ListItem)`
    && {
        padding: 8px 16px;
        display: flex;
        justify-content: space-between;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
`